const rootElement = document.getElementById('tx-user-blog-entry-list')
const {
  parseAllowedCategories,
  parsePositiveInteger
} = require('./config-parser.cjs')

const dataset = rootElement ? rootElement.dataset : {}

export const blogListConfig = Object.freeze({
  apiBase: dataset.apiBase || '',
  locale: dataset.locale || 'de-DE',
  categoryUid: parsePositiveInteger(dataset.categoryUid, 0),
  allowedCategories: parseAllowedCategories(dataset.allowedCategories),
  categoryHeadline: dataset.categoryHeadline || '',
  disableSpecial: dataset.disableSpecial === 'true',
  itemsPerPage: parsePositiveInteger(dataset.itemsPerPage, 13),
  billboardPosition: parsePositiveInteger(dataset.billboardPosition, 7)
})

export { rootElement }
